module.exports = __webpack_public_path__ + "static/media/art_14-2.7fa10d01.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/art_14-2.png
// module id = 690
// module chunks = 0